import { useEffect } from 'react';

import { useGetPaymentSystemsQuery } from '@/modules/payment-systems';
import { showError } from '@/shared';

export const useGetPaymentSystems = () => {
  const { data, isLoading, isError } = useGetPaymentSystemsQuery();

  useEffect(() => {
    if (isError) {
      showError({ message: 'Произошла ошибка!' });
    }
  }, [isError]);

  return {
    data,
    isLoading,
  };
};
